import { GetUserComplianceCasesQuery } from "../graphql/supergraphTypes";

export type UserAccessibleComplianceCase =
  GetUserComplianceCasesQuery["userAccessibleComplianceCases"][0];

export enum LandingUIState {
  Confirmation = "confirmation",
  Compliance = "compliance",
  Completion = "completion",
  CaseNotFound = "case_not_found",
}
